import { Compass } from "@phosphor-icons/react";

import { Tag } from "common/components/ui/Tag";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "common/components/ui/Tooltip/Tooltip";

interface SalesNavigatorTagProps {
  hasContract: boolean;
}

export default function SalesNavigatorTag({
  hasContract,
}: SalesNavigatorTagProps) {
  const tagComponent = (
    <Tag
      variant={hasContract ? "info" : "disabled"}
      size="sm"
      leftIcon={
        <Compass weight="fill" className={hasContract && "text-blue-500"} />
      }
    >
      Sales Navigator
    </Tag>
  );

  if (!hasContract) {
    return (
      <Tooltip>
        <TooltipTrigger asChild>{tagComponent}</TooltipTrigger>
        <TooltipContent>
          This conversation is inactive because your Sales Navigator contract
          has expired.
        </TooltipContent>
      </Tooltip>
    );
  }

  return tagComponent;
}
